// // // // import React, { useState, useEffect } from 'react';
// // // // import {
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   Button,
// // // //   Box,
// // // //   Typography,
// // // //   Grid,
// // // //   TextField,
// // // //   Checkbox,
// // // //   FormControlLabel,
// // // //   Paper,
// // // //   Stack
// // // // } from '@mui/material';
// // // // import api from '../../../api/axiosInterceptor';
// // // // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // // const InstallmentEditModal = ({ open, onClose, excessId }) => {
// // // //   const [installments, setInstallments] = useState([]);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [updatingIndex, setUpdatingIndex] = useState(null);

// // // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // // //   const [snackbarMessage, setSnackbarMessage] = useState('');
// // // //   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

// // // //   // Fetch installments
// // // //   const fetchInstallments = async () => {
// // // //     if (!excessId) return;
// // // //     try {
// // // //       setLoading(true);
// // // //       const res = await api.get(`/excess_payment_mgmt/excess-installment-updater/${excessId}/`);
// // // //       setInstallments(res.data);
// // // //     } catch (err) {
// // // //       setSnackbarMessage(err.response?.data?.error || 'Failed to load installments');
// // // //       setSnackbarSeverity('error');
// // // //       setSnackbarOpen(true);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     if (open) fetchInstallments();
// // // //   }, [open, excessId]);

// // // //   // Handle changes in form fields
// // // //   const handleChange = (index, field, value) => {
// // // //     const updated = [...installments];
// // // //     updated[index][field] = value;

// // // //     // Auto-mark installment as updated if marked paid
// // // //     if (field === 'is_paid' && value === true) {
// // // //       updated[index].is_updated = true;
// // // //     }

// // // //     setInstallments(updated);
// // // //   };

// // // //   const handleUpdateInstallment = async (index) => {
// // // //     if (!excessId) return;
// // // //     const installment = installments[index];
// // // //     const installmentId = installment.id;

// // // //     // Prepare payload
// // // //     const payload = {};
// // // //     Object.keys(installment).forEach((key) => {
// // // //       if (installment[key] !== undefined) payload[key] = installment[key];
// // // //     });

// // // //     try {
// // // //       setUpdatingIndex(index);
// // // //       await api.patch(
// // // //         `/excess_payment_mgmt/excess-installment-updater/${excessId}/${installmentId}/`,
// // // //         payload
// // // //       );
// // // //       setSnackbarMessage('Installment updated successfully');
// // // //       setSnackbarSeverity('success');
// // // //       setSnackbarOpen(true);

// // // //       // Update state to mark installment as updated
// // // //       const updatedInstallments = [...installments];
// // // //       updatedInstallments[index].is_updated = true;
// // // //       setInstallments(updatedInstallments);

// // // //     } catch (err) {
// // // //       setSnackbarMessage(err.response?.data?.error || 'Failed to update installment');
// // // //       setSnackbarSeverity('error');
// // // //       setSnackbarOpen(true);
// // // //     } finally {
// // // //       setUpdatingIndex(null);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <>
// // // //       <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
// // // //         <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
// // // //           Edit Installments
// // // //         </DialogTitle>

// // // //         <DialogContent dividers>
// // // //           <Stack spacing={3}>
// // // //             {loading ? (
// // // //               <Typography>Loading...</Typography>
// // // //             ) : installments.length === 0 ? (
// // // //               <Typography>No installments found</Typography>
// // // //             ) : (
// // // //               installments.map((inst, idx) => {
// // // //                 const isPaid = inst.is_paid || false;

// // // //                 // Only allow editing if first OR previous installment is paid or updated
// // // //                 const canEdit =
// // // //                   idx === 0 || installments[idx - 1]?.is_paid || installments[idx - 1]?.is_updated;

// // // //                 return (
// // // //                   <Paper
// // // //                     key={inst.id}
// // // //                     elevation={3}
// // // //                     sx={{ p: 3, borderRadius: 2, position: 'relative', opacity: canEdit ? 1 : 0.6 }}
// // // //                   >
// // // //                     <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
// // // //                       Installment {idx + 1}
// // // //                     </Typography>

// // // //                     <Grid container spacing={2}>
// // // //                       <Grid item xs={12} md={4}>
// // // //                         <TextField
// // // //                           label="Installment Amount"
// // // //                           type="number"
// // // //                           fullWidth
// // // //                           value={inst.installment_amount || ''}
// // // //                           onChange={(e) =>
// // // //                             handleChange(idx, 'installment_amount', e.target.value)
// // // //                           }
// // // //                           disabled={!canEdit}
// // // //                         />
// // // //                       </Grid>

// // // //                       <Grid item xs={12} md={4}>
// // // //                         <TextField
// // // //                           label="Due Date"
// // // //                           type="date"
// // // //                           fullWidth
// // // //                           value={inst.installment_due_date || ''}
// // // //                           onChange={(e) =>
// // // //                             handleChange(idx, 'installment_due_date', e.target.value)
// // // //                           }
// // // //                           InputLabelProps={{ shrink: true }}
// // // //                           disabled={!canEdit}
// // // //                         />
// // // //                       </Grid>

// // // //                       <Grid item xs={12} md={4}>
// // // //                         <FormControlLabel
// // // //                           control={
// // // //                             <Checkbox
// // // //                               checked={isPaid}
// // // //                               onChange={(e) =>
// // // //                                 handleChange(idx, 'is_paid', e.target.checked)
// // // //                               }
// // // //                               disabled={!canEdit}
// // // //                             />
// // // //                           }
// // // //                           label="Paid"
// // // //                         />
// // // //                       </Grid>

// // // //                       <Grid item xs={12} md={4}>
// // // //                         <TextField
// // // //                           label="Paid On"
// // // //                           type="datetime-local"
// // // //                           fullWidth
// // // //                           value={inst.paid_on ? inst.paid_on.slice(0, 16) : ''}
// // // //                           onChange={(e) => handleChange(idx, 'paid_on', e.target.value)}
// // // //                           InputLabelProps={{ shrink: true }}
// // // //                           disabled={!isPaid || !canEdit}
// // // //                         />
// // // //                       </Grid>

// // // //                       <Grid item xs={12} md={4}>
// // // //                         <TextField
// // // //                           label="Particulars"
// // // //                           fullWidth
// // // //                           value={inst.particulars || ''}
// // // //                           onChange={(e) => handleChange(idx, 'particulars', e.target.value)}
// // // //                           disabled={!isPaid || !canEdit}
// // // //                         />
// // // //                       </Grid>

// // // //                       <Grid item xs={12} md={4}>
// // // //                         <TextField
// // // //                           label="Payment Reference Number"
// // // //                           fullWidth
// // // //                           value={inst.payment_reference_number || ''}
// // // //                           onChange={(e) =>
// // // //                             handleChange(idx, 'payment_reference_number', e.target.value)
// // // //                           }
// // // //                           disabled={!isPaid || !canEdit}
// // // //                         />
// // // //                       </Grid>

// // // //                       <Grid item xs={12} md={4}>
// // // //                         <TextField
// // // //                           label="Amount Received Bank"
// // // //                           type="text"
// // // //                           fullWidth
// // // //                           value={inst.amt_received_bank_name || ''}
// // // //                           onChange={(e) =>
// // // //                             handleChange(idx, 'amt_received_bank_name', e.target.value)
// // // //                           }
// // // //                           disabled={!isPaid || !canEdit}
// // // //                         />
// // // //                       </Grid>

// // // //                       <Grid item xs={12} md={4}>
// // // //                         <FormControlLabel
// // // //                           control={
// // // //                             <Checkbox
// // // //                               checked={inst.is_amt_received_office || false}
// // // //                               onChange={(e) =>
// // // //                                 handleChange(idx, 'is_amt_received_office', e.target.checked)
// // // //                               }
// // // //                               disabled={!isPaid || !canEdit}
// // // //                             />
// // // //                           }
// // // //                           label="Amount Received"
// // // //                         />
// // // //                       </Grid>

// // // //                       <Grid item xs={12} md={4}>
// // // //                         <TextField
// // // //                           label="Amount Received On"
// // // //                           type="datetime-local"
// // // //                           fullWidth
// // // //                           value={inst.amt_received_office_on ? inst.amt_received_office_on.slice(0,16) : ''}
// // // //                           onChange={(e) =>
// // // //                             handleChange(idx, 'amt_received_office_on', e.target.value)
// // // //                           }
// // // //                           InputLabelProps={{ shrink: true }}
// // // //                           disabled={!isPaid || !canEdit}
// // // //                         />
// // // //                       </Grid>

// // // //                     </Grid>
// // // //                     <Box mt={2}>
// // // //                       <Grid item xs={12}>
// // // //                         <TextField
// // // //                           label="Remarks(Add Brief Notes for Office Use)"
// // // //                           fullWidth
// // // //                           multiline
// // // //                           rows={2}
// // // //                           value={inst.remarks || ''}
// // // //                           onChange={(e) => handleChange(idx, 'remarks', e.target.value)}
// // // //                           disabled={!canEdit}
// // // //                         />
// // // //                       </Grid>
// // // //                     </Box>

// // // //                     <Box mt={2} textAlign="right">
// // // //                       <Button
// // // //                         variant="contained"
// // // //                         color="primary"
// // // //                         onClick={() => handleUpdateInstallment(idx)}
// // // //                         disabled={!canEdit || updatingIndex === idx}
// // // //                       >
// // // //                         {updatingIndex === idx ? 'Updating...' : 'Update'}
// // // //                       </Button>
// // // //                     </Box>
// // // //                   </Paper>
// // // //                 );
// // // //               })
// // // //             )}
// // // //           </Stack>
// // // //         </DialogContent>

// // // //         <DialogActions>
// // // //           <Button onClick={onClose} variant="outlined">
// // // //             Close
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>

// // // //       <SnackBarComponent
// // // //         open={snackbarOpen}
// // // //         message={snackbarMessage}
// // // //         severity={snackbarSeverity}
// // // //         onClose={() => setSnackbarOpen(false)}
// // // //       />
// // // //     </>
// // // //   );
// // // // };

// // // // export default InstallmentEditModal;

// // // import React, { useState, useEffect } from 'react';
// // // import {
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   Button,
// // //   Box,
// // //   Typography,
// // //   Grid,
// // //   TextField,
// // //   Checkbox,
// // //   FormControlLabel,
// // //   Paper,
// // //   Stack
// // // } from '@mui/material';
// // // import api from '../../../api/axiosInterceptor';
// // // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // const InstallmentEditModal = ({ open, onClose, excessId }) => {
// // //   const [installments, setInstallments] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [updatingIndex, setUpdatingIndex] = useState(null);
// // //   const [hasFetched, setHasFetched] = useState(false);

// // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // //   const [snackbarMessage, setSnackbarMessage] = useState('');
// // //   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

// // //   const fetchInstallments = async () => {
// // //     if (!excessId) {
// // //       setInstallments([]);
// // //       setHasFetched(true);
// // //       return;
// // //     }

// // //     try {
// // //       setLoading(true);
// // //       setHasFetched(false);
// // //       const res = await api.get(`/excess_payment_mgmt/excess-installment-updater/${excessId}/`);
// // //       setInstallments(Array.isArray(res.data) ? res.data : []);
// // //       setHasFetched(true);
// // //       if (!Array.isArray(res.data) || res.data.length === 0) {
// // //         setSnackbarMessage('No Installment Found Please add it from Manage Document');
// // //         setSnackbarSeverity('success');
// // //         setSnackbarOpen(true);
// // //       }
// // //     } catch (err) {
// // //       setInstallments([]);
// // //       setHasFetched(true);
// // //       setSnackbarMessage(err.response?.data?.error || 'Failed to load installments');
// // //       setSnackbarSeverity('error');
// // //       setSnackbarOpen(true);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     if (open) {
// // //       fetchInstallments();
// // //     } else {
// // //       setInstallments([]);
// // //       setHasFetched(false);
// // //       setUpdatingIndex(null);
// // //       setLoading(false);
// // //     }
// // //   }, [open, excessId]);

// // //   const handleChange = (index, field, value) => {
// // //     const updated = [...installments];
// // //     updated[index][field] = value;

// // //     if (field === 'is_paid' && value === true) {
// // //       updated[index].is_updated = true;
// // //     }

// // //     setInstallments(updated);
// // //   };

// // //   const handleUpdateInstallment = async (index) => {
// // //     if (!excessId) return;
// // //     const installment = installments[index];
// // //     const installmentId = installment.id;

// // //     const payload = {};
// // //     Object.keys(installment).forEach((key) => {
// // //       if (installment[key] !== undefined) payload[key] = installment[key];
// // //     });

// // //     try {
// // //       setUpdatingIndex(index);
// // //       await api.patch(
// // //         `/excess_payment_mgmt/excess-installment-updater/${excessId}/${installmentId}/`,
// // //         payload
// // //       );
// // //       setSnackbarMessage('Installment updated successfully');
// // //       setSnackbarSeverity('success');
// // //       setSnackbarOpen(true);

// // //       const updatedInstallments = [...installments];
// // //       updatedInstallments[index].is_updated = true;
// // //       setInstallments(updatedInstallments);
// // //     } catch (err) {
// // //       setSnackbarMessage(err.response?.data?.error || 'Failed to update installment');
// // //       setSnackbarSeverity('error');
// // //       setSnackbarOpen(true);
// // //     } finally {
// // //       setUpdatingIndex(null);
// // //     }
// // //   };

// // //   return (
// // //     <>
// // //       <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
// // //         <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
// // //           Edit Installments
// // //         </DialogTitle>

// // //         <DialogContent dividers>
// // //           <Stack spacing={3}>
// // //             {loading ? (
// // //               <Typography>Loading...</Typography>
// // //             ) : hasFetched && installments.length === 0 ? (
// // //               <Typography color="success.main" sx={{ fontWeight: 600 }}>
// // //                 No Installment Found Please add it from Manage Document
// // //               </Typography>
// // //             ) : (
// // //               installments.map((inst, idx) => {
// // //                 const isPaid = inst.is_paid || false;

// // //                 const canEdit =
// // //                   idx === 0 || installments[idx - 1]?.is_paid || installments[idx - 1]?.is_updated;

// // //                 return (
// // //                   <Paper
// // //                     key={inst.id}
// // //                     elevation={3}
// // //                     sx={{ p: 3, borderRadius: 2, position: 'relative', opacity: canEdit ? 1 : 0.6 }}
// // //                   >
// // //                     <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
// // //                       Installment {idx + 1}
// // //                     </Typography>

// // //                     <Grid container spacing={2}>
// // //                       <Grid item xs={12} md={4}>
// // //                         <TextField
// // //                           label="Installment Amount"
// // //                           type="number"
// // //                           fullWidth
// // //                           value={inst.installment_amount || ''}
// // //                           InputProps={{ readOnly: true }}
// // //                         />
// // //                       </Grid>

// // //                       <Grid item xs={12} md={4}>
// // //                         <TextField
// // //                           label="Due Date"
// // //                           type="date"
// // //                           fullWidth
// // //                           value={inst.installment_due_date || ''}
// // //                           onChange={(e) =>
// // //                             handleChange(idx, 'installment_due_date', e.target.value)
// // //                           }
// // //                           InputLabelProps={{ shrink: true }}
// // //                           disabled={!canEdit}
// // //                         />
// // //                       </Grid>

// // //                       <Grid item xs={12} md={4}>
// // //                         <FormControlLabel
// // //                           control={
// // //                             <Checkbox
// // //                               checked={isPaid}
// // //                               onChange={(e) =>
// // //                                 handleChange(idx, 'is_paid', e.target.checked)
// // //                               }
// // //                               disabled={!canEdit}
// // //                             />
// // //                           }
// // //                           label="Paid"
// // //                         />
// // //                       </Grid>

// // //                       <Grid item xs={12} md={4}>
// // //                         <TextField
// // //                           label="Paid On"
// // //                           type="datetime-local"
// // //                           fullWidth
// // //                           value={inst.paid_on ? inst.paid_on.slice(0, 16) : ''}
// // //                           onChange={(e) => handleChange(idx, 'paid_on', e.target.value)}
// // //                           InputLabelProps={{ shrink: true }}
// // //                           disabled={!isPaid || !canEdit}
// // //                         />
// // //                       </Grid>

// // //                       <Grid item xs={12} md={4}>
// // //                         <TextField
// // //                           label="Particulars"
// // //                           fullWidth
// // //                           value={inst.particulars || ''}
// // //                           onChange={(e) => handleChange(idx, 'particulars', e.target.value)}
// // //                           disabled={!isPaid || !canEdit}
// // //                         />
// // //                       </Grid>

// // //                       <Grid item xs={12} md={4}>
// // //                         <TextField
// // //                           label="Payment Reference Number"
// // //                           fullWidth
// // //                           value={inst.payment_reference_number || ''}
// // //                           onChange={(e) =>
// // //                             handleChange(idx, 'payment_reference_number', e.target.value)
// // //                           }
// // //                           disabled={!isPaid || !canEdit}
// // //                         />
// // //                       </Grid>

// // //                       <Grid item xs={12} md={4}>
// // //                         <TextField
// // //                           label="Amount Received Bank"
// // //                           type="text"
// // //                           fullWidth
// // //                           value={inst.amt_received_bank_name || ''}
// // //                           onChange={(e) =>
// // //                             handleChange(idx, 'amt_received_bank_name', e.target.value)
// // //                           }
// // //                           disabled={!isPaid || !canEdit}
// // //                         />
// // //                       </Grid>

// // //                       <Grid item xs={12} md={4}>
// // //                         <FormControlLabel
// // //                           control={
// // //                             <Checkbox
// // //                               checked={inst.is_amt_received_office || false}
// // //                               onChange={(e) =>
// // //                                 handleChange(idx, 'is_amt_received_office', e.target.checked)
// // //                               }
// // //                               disabled={!isPaid || !canEdit}
// // //                             />
// // //                           }
// // //                           label="Amount Received"
// // //                         />
// // //                       </Grid>

// // //                       <Grid item xs={12} md={4}>
// // //                         <TextField
// // //                           label="Amount Received On"
// // //                           type="datetime-local"
// // //                           fullWidth
// // //                           value={inst.amt_received_office_on ? inst.amt_received_office_on.slice(0,16) : ''}
// // //                           onChange={(e) =>
// // //                             handleChange(idx, 'amt_received_office_on', e.target.value)
// // //                           }
// // //                           InputLabelProps={{ shrink: true }}
// // //                           disabled={!isPaid || !canEdit}
// // //                         />
// // //                       </Grid>
// // //                     </Grid>

// // //                     <Box mt={2}>
// // //                       <Grid item xs={12}>
// // //                         <TextField
// // //                           label="Remarks(Add Brief Notes for Office Use)"
// // //                           fullWidth
// // //                           multiline
// // //                           rows={2}
// // //                           value={inst.remarks || ''}
// // //                           onChange={(e) => handleChange(idx, 'remarks', e.target.value)}
// // //                           disabled={!canEdit}
// // //                         />
// // //                       </Grid>
// // //                     </Box>

// // //                     <Box mt={2} textAlign="right">
// // //                       <Button
// // //                         variant="contained"
// // //                         color="primary"
// // //                         onClick={() => handleUpdateInstallment(idx)}
// // //                         disabled={!canEdit || updatingIndex === idx}
// // //                       >
// // //                         {updatingIndex === idx ? 'Updating...' : 'Update'}
// // //                       </Button>
// // //                     </Box>
// // //                   </Paper>
// // //                 );
// // //               })
// // //             )}
// // //           </Stack>
// // //         </DialogContent>

// // //         <DialogActions>
// // //           <Button onClick={onClose} variant="outlined">
// // //             Close
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>

// // //       <SnackBarComponent
// // //         open={snackbarOpen}
// // //         message={snackbarMessage}
// // //         severity={snackbarSeverity}
// // //         onClose={() => setSnackbarOpen(false)}
// // //       />
// // //     </>
// // //   );
// // // };

// // // export default InstallmentEditModal;


// // import React, { useState, useEffect } from 'react';
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// //   Box,
// //   Typography,
// //   Grid,
// //   TextField,
// //   Checkbox,
// //   FormControlLabel,
// //   Paper,
// //   Stack,
// //   Chip,
// // } from '@mui/material';
// // import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// // import api from '../../../api/axiosInterceptor';
// // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // readOnly: true once the case is closed — every field/button below is
// // // disabled so the installment history stays fully visible but uneditable.
// // const InstallmentEditModal = ({ open, onClose, excessId, readOnly = false }) => {
// //   const [installments, setInstallments] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [updatingIndex, setUpdatingIndex] = useState(null);
// //   const [hasFetched, setHasFetched] = useState(false);

// //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// //   const [snackbarMessage, setSnackbarMessage] = useState('');
// //   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

// //   const fetchInstallments = async () => {
// //     if (!excessId) {
// //       setInstallments([]);
// //       setHasFetched(true);
// //       return;
// //     }

// //     try {
// //       setLoading(true);
// //       setHasFetched(false);
// //       const res = await api.get(`/excess_payment_mgmt/excess-installment-updater/${excessId}/`);
// //       setInstallments(Array.isArray(res.data) ? res.data : []);
// //       setHasFetched(true);
// //       if (!Array.isArray(res.data) || res.data.length === 0) {
// //         setSnackbarMessage('No Installment Found Please add it from Manage Document');
// //         setSnackbarSeverity('success');
// //         setSnackbarOpen(true);
// //       }
// //     } catch (err) {
// //       setInstallments([]);
// //       setHasFetched(true);
// //       setSnackbarMessage(err.response?.data?.error || 'Failed to load installments');
// //       setSnackbarSeverity('error');
// //       setSnackbarOpen(true);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (open) {
// //       fetchInstallments();
// //     } else {
// //       setInstallments([]);
// //       setHasFetched(false);
// //       setUpdatingIndex(null);
// //       setLoading(false);
// //     }
// //   }, [open, excessId]);

// //   const handleChange = (index, field, value) => {
// //     if (readOnly) return;
// //     const updated = [...installments];
// //     updated[index][field] = value;

// //     if (field === 'is_paid' && value === true) {
// //       updated[index].is_updated = true;
// //     }

// //     setInstallments(updated);
// //   };

// //   const handleUpdateInstallment = async (index) => {
// //     if (readOnly || !excessId) return;
// //     const installment = installments[index];
// //     const installmentId = installment.id;

// //     const payload = {};
// //     Object.keys(installment).forEach((key) => {
// //       if (installment[key] !== undefined) payload[key] = installment[key];
// //     });

// //     try {
// //       setUpdatingIndex(index);
// //       await api.patch(
// //         `/excess_payment_mgmt/excess-installment-updater/${excessId}/${installmentId}/`,
// //         payload
// //       );
// //       setSnackbarMessage('Installment updated successfully');
// //       setSnackbarSeverity('success');
// //       setSnackbarOpen(true);

// //       const updatedInstallments = [...installments];
// //       updatedInstallments[index].is_updated = true;
// //       setInstallments(updatedInstallments);
// //     } catch (err) {
// //       setSnackbarMessage(err.response?.data?.error || 'Failed to update installment');
// //       setSnackbarSeverity('error');
// //       setSnackbarOpen(true);
// //     } finally {
// //       setUpdatingIndex(null);
// //     }
// //   };

// //   return (
// //     <>
// //       <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
// //         <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem', display: 'flex', alignItems: 'center', gap: 1.5 }}>
// //           Edit Installments
// //           {readOnly && (
// //             <Chip
// //               icon={<LockOutlinedIcon fontSize="small" />}
// //               label="Closed — View Only"
// //               size="small"
// //               sx={{ fontWeight: 600 }}
// //             />
// //           )}
// //         </DialogTitle>

// //         <DialogContent dividers>
// //           <Stack spacing={3}>
// //             {loading ? (
// //               <Typography>Loading...</Typography>
// //             ) : hasFetched && installments.length === 0 ? (
// //               <Typography color="success.main" sx={{ fontWeight: 600 }}>
// //                 No Installment Found Please add it from Manage Document
// //               </Typography>
// //             ) : (
// //               installments.map((inst, idx) => {
// //                 const isPaid = inst.is_paid || false;

// //                 const canEdit =
// //                   !readOnly &&
// //                   (idx === 0 || installments[idx - 1]?.is_paid || installments[idx - 1]?.is_updated);

// //                 return (
// //                   <Paper
// //                     key={inst.id}
// //                     elevation={3}
// //                     sx={{ p: 3, borderRadius: 2, position: 'relative', opacity: canEdit ? 1 : 0.6 }}
// //                   >
// //                     <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
// //                       Installment {idx + 1}
// //                     </Typography>

// //                     <Grid container spacing={2}>
// //                       <Grid item xs={12} md={4}>
// //                         <TextField
// //                           label="Installment Amount"
// //                           type="number"
// //                           fullWidth
// //                           value={inst.installment_amount || ''}
// //                           InputProps={{ readOnly: true }}
// //                         />
// //                       </Grid>

// //                       <Grid item xs={12} md={4}>
// //                         <TextField
// //                           label="Due Date"
// //                           type="date"
// //                           fullWidth
// //                           value={inst.installment_due_date || ''}
// //                           onChange={(e) =>
// //                             handleChange(idx, 'installment_due_date', e.target.value)
// //                           }
// //                           InputLabelProps={{ shrink: true }}
// //                           disabled={!canEdit}
// //                         />
// //                       </Grid>

// //                       <Grid item xs={12} md={4}>
// //                         <FormControlLabel
// //                           control={
// //                             <Checkbox
// //                               checked={isPaid}
// //                               onChange={(e) =>
// //                                 handleChange(idx, 'is_paid', e.target.checked)
// //                               }
// //                               disabled={!canEdit}
// //                             />
// //                           }
// //                           label="Paid"
// //                         />
// //                       </Grid>

// //                       <Grid item xs={12} md={4}>
// //                         <TextField
// //                           label="Paid On"
// //                           type="datetime-local"
// //                           fullWidth
// //                           value={inst.paid_on ? inst.paid_on.slice(0, 16) : ''}
// //                           onChange={(e) => handleChange(idx, 'paid_on', e.target.value)}
// //                           InputLabelProps={{ shrink: true }}
// //                           disabled={!isPaid || !canEdit}
// //                         />
// //                       </Grid>

// //                       <Grid item xs={12} md={4}>
// //                         <TextField
// //                           label="Particulars"
// //                           fullWidth
// //                           value={inst.particulars || ''}
// //                           onChange={(e) => handleChange(idx, 'particulars', e.target.value)}
// //                           disabled={!isPaid || !canEdit}
// //                         />
// //                       </Grid>

// //                       <Grid item xs={12} md={4}>
// //                         <TextField
// //                           label="Payment Reference Number"
// //                           fullWidth
// //                           value={inst.payment_reference_number || ''}
// //                           onChange={(e) =>
// //                             handleChange(idx, 'payment_reference_number', e.target.value)
// //                           }
// //                           disabled={!isPaid || !canEdit}
// //                         />
// //                       </Grid>

// //                       <Grid item xs={12} md={4}>
// //                         <TextField
// //                           label="Amount Received Bank"
// //                           type="text"
// //                           fullWidth
// //                           value={inst.amt_received_bank_name || ''}
// //                           onChange={(e) =>
// //                             handleChange(idx, 'amt_received_bank_name', e.target.value)
// //                           }
// //                           disabled={!isPaid || !canEdit}
// //                         />
// //                       </Grid>

// //                       <Grid item xs={12} md={4}>
// //                         <FormControlLabel
// //                           control={
// //                             <Checkbox
// //                               checked={inst.is_amt_received_office || false}
// //                               onChange={(e) =>
// //                                 handleChange(idx, 'is_amt_received_office', e.target.checked)
// //                               }
// //                               disabled={!isPaid || !canEdit}
// //                             />
// //                           }
// //                           label="Amount Received"
// //                         />
// //                       </Grid>

// //                       <Grid item xs={12} md={4}>
// //                         <TextField
// //                           label="Amount Received On"
// //                           type="datetime-local"
// //                           fullWidth
// //                           value={inst.amt_received_office_on ? inst.amt_received_office_on.slice(0,16) : ''}
// //                           onChange={(e) =>
// //                             handleChange(idx, 'amt_received_office_on', e.target.value)
// //                           }
// //                           InputLabelProps={{ shrink: true }}
// //                           disabled={!isPaid || !canEdit}
// //                         />
// //                       </Grid>
// //                     </Grid>

// //                     <Box mt={2}>
// //                       <Grid item xs={12}>
// //                         <TextField
// //                           label="Remarks(Add Brief Notes for Office Use)"
// //                           fullWidth
// //                           multiline
// //                           rows={2}
// //                           value={inst.remarks || ''}
// //                           onChange={(e) => handleChange(idx, 'remarks', e.target.value)}
// //                           disabled={!canEdit}
// //                         />
// //                       </Grid>
// //                     </Box>

// //                     {!readOnly && (
// //                       <Box mt={2} textAlign="right">
// //                         <Button
// //                           variant="contained"
// //                           color="primary"
// //                           onClick={() => handleUpdateInstallment(idx)}
// //                           disabled={!canEdit || updatingIndex === idx}
// //                         >
// //                           {updatingIndex === idx ? 'Updating...' : 'Update'}
// //                         </Button>
// //                       </Box>
// //                     )}
// //                   </Paper>
// //                 );
// //               })
// //             )}
// //           </Stack>
// //         </DialogContent>

// //         <DialogActions>
// //           <Button onClick={onClose} variant="outlined">
// //             Close
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       <SnackBarComponent
// //         open={snackbarOpen}
// //         message={snackbarMessage}
// //         severity={snackbarSeverity}
// //         onClose={() => setSnackbarOpen(false)}
// //       />
// //     </>
// //   );
// // };

// // export default InstallmentEditModal;


// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   Grid,
//   TextField,
//   Checkbox,
//   FormControlLabel,
//   Paper,
//   Stack,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   IconButton,
//   Tooltip,
//   Link,
// } from '@mui/material';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import UploadFileIcon from '@mui/icons-material/UploadFile';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import api from '../../../api/axiosInterceptor';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { PAYMENT_METHOD_OPTIONS, MAX_INSTALLMENT_STATEMENT_FILE_SIZE } from './workflowApi';

// const PRESET_METHODS = PAYMENT_METHOD_OPTIONS.filter((m) => m !== 'Others');

// // readOnly: true once the case is closed — every field/button below is
// // disabled so the installment history stays fully visible but uneditable.
// const InstallmentEditModal = ({ open, onClose, excessId, readOnly = false }) => {
//   const [installments, setInstallments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [updatingIndex, setUpdatingIndex] = useState(null);
//   const [hasFetched, setHasFetched] = useState(false);
//   const [stagedFiles, setStagedFiles] = useState({}); // { [idx]: File }

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');

//   const showError = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity('error');
//     setSnackbarOpen(true);
//   };

//   // Augments each installment with transient (never sent to the backend)
//   // UI-only fields so the "Paid By" dropdown can tell a preset method apart
//   // from a custom "Others" value that's already stored in `payment_method`.
//   const enrich = (list) =>
//     list.map((item) => {
//       const isPreset = PRESET_METHODS.includes(item.payment_method);
//       return {
//         ...item,
//         _paymentMethodMode: item.payment_method ? (isPreset ? item.payment_method : 'Others') : '',
//         _customPaymentMethod: item.payment_method && !isPreset ? item.payment_method : '',
//       };
//     });

//   const fetchInstallments = async () => {
//     if (!excessId) {
//       setInstallments([]);
//       setHasFetched(true);
//       return;
//     }

//     try {
//       setLoading(true);
//       setHasFetched(false);
//       const res = await api.get(`/excess_payment_mgmt/excess-installment-updater/${excessId}/`);
//       setInstallments(Array.isArray(res.data) ? enrich(res.data) : []);
//       setStagedFiles({});
//       setHasFetched(true);
//       if (!Array.isArray(res.data) || res.data.length === 0) {
//         setSnackbarMessage('No Installment Found Please add it from Manage Document');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//       }
//     } catch (err) {
//       setInstallments([]);
//       setHasFetched(true);
//       showError(err.response?.data?.error || 'Failed to load installments');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchInstallments();
//     } else {
//       setInstallments([]);
//       setStagedFiles({});
//       setHasFetched(false);
//       setUpdatingIndex(null);
//       setLoading(false);
//     }
//   }, [open, excessId]);

//   const handleChange = (index, field, value) => {
//     if (readOnly) return;
//     const updated = [...installments];
//     updated[index][field] = value;

//     if (field === 'is_paid' && value === true) {
//       updated[index].is_updated = true;
//     }

//     setInstallments(updated);
//   };

//   // "Paid By" — preset methods write straight into payment_method; "Others"
//   // switches the UI into free-text mode without touching payment_method
//   // until the user actually types something, so a stray "Others" click
//   // doesn't overwrite a previously-saved custom value.
//   const handlePaymentMethodSelect = (index, value) => {
//     if (readOnly) return;
//     const updated = [...installments];
//     updated[index]._paymentMethodMode = value;
//     if (value !== 'Others') {
//       updated[index].payment_method = value;
//       updated[index]._customPaymentMethod = '';
//     } else if (!updated[index]._customPaymentMethod) {
//       updated[index].payment_method = '';
//     }
//     setInstallments(updated);
//   };

//   const handleCustomPaymentMethodChange = (index, value) => {
//     if (readOnly) return;
//     const updated = [...installments];
//     updated[index]._customPaymentMethod = value;
//     updated[index].payment_method = value; // stored directly in the same key
//     setInstallments(updated);
//   };

//   const handleStatementFileChange = (index) => (e) => {
//     if (readOnly) return;
//     const file = e.target.files?.[0];
//     if (!file) return;
//     if (file.size > MAX_INSTALLMENT_STATEMENT_FILE_SIZE) {
//       showError(`Statement must be under ${Math.round(MAX_INSTALLMENT_STATEMENT_FILE_SIZE / (1024 * 1024))} MB.`);
//       return;
//     }
//     setStagedFiles((prev) => ({ ...prev, [index]: file }));
//   };

//   const handleUpdateInstallment = async (index) => {
//     if (readOnly || !excessId) return;
//     const installment = installments[index];
//     const installmentId = installment.id;

//     const fd = new FormData();
//     Object.keys(installment).forEach((key) => {
//       // Skip transient UI-only fields — the backend has no columns for these.
//       if (key.startsWith('_')) return;
//       if (installment[key] !== undefined && installment[key] !== null) {
//         fd.append(key, installment[key]);
//       }
//     });
//     if (stagedFiles[index]) {
//       fd.append('statement_file', stagedFiles[index]);
//     }

//     try {
//       setUpdatingIndex(index);
//       const res = await api.patch(
//         `/excess_payment_mgmt/excess-installment-updater/${excessId}/${installmentId}/`,
//         fd,
//         { headers: { 'Content-Type': 'multipart/form-data' } }
//       );
//       setSnackbarMessage('Installment updated successfully');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);

//       const updatedInstallments = [...installments];
//       updatedInstallments[index] = {
//         ...updatedInstallments[index],
//         ...(res.data?.data || {}),
//         is_updated: true,
//       };
//       setInstallments(enrich(updatedInstallments));
//       setStagedFiles((prev) => {
//         const next = { ...prev };
//         delete next[index];
//         return next;
//       });
//     } catch (err) {
//       showError(err.response?.data?.error || 'Failed to update installment');
//     } finally {
//       setUpdatingIndex(null);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
//         <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem', display: 'flex', alignItems: 'center', gap: 1.5 }}>
//           Edit Installments
//           {readOnly && (
//             <Chip
//               icon={<LockOutlinedIcon fontSize="small" />}
//               label="Closed — View Only"
//               size="small"
//               sx={{ fontWeight: 600 }}
//             />
//           )}
//         </DialogTitle>

//         <DialogContent dividers>
//           <Stack spacing={3}>
//             {loading ? (
//               <Typography>Loading...</Typography>
//             ) : hasFetched && installments.length === 0 ? (
//               <Typography color="success.main" sx={{ fontWeight: 600 }}>
//                 No Installment Found Please add it from Manage Document
//               </Typography>
//             ) : (
//               installments.map((inst, idx) => {
//                 const isPaid = inst.is_paid || false;

//                 const canEdit =
//                   !readOnly &&
//                   (idx === 0 || installments[idx - 1]?.is_paid || installments[idx - 1]?.is_updated);

//                 return (
//                   <Paper
//                     key={inst.id}
//                     elevation={3}
//                     sx={{ p: 3, borderRadius: 2, position: 'relative', opacity: canEdit ? 1 : 0.6 }}
//                   >
//                     <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//                       Installment {idx + 1}
//                     </Typography>

//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={4}>
//                         <TextField
//                           label="Installment Amount"
//                           type="number"
//                           fullWidth
//                           value={inst.installment_amount || ''}
//                           InputProps={{ readOnly: true }}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <TextField
//                           label="Due Date"
//                           type="date"
//                           fullWidth
//                           value={inst.installment_due_date || ''}
//                           onChange={(e) =>
//                             handleChange(idx, 'installment_due_date', e.target.value)
//                           }
//                           InputLabelProps={{ shrink: true }}
//                           disabled={!canEdit}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={isPaid}
//                               onChange={(e) =>
//                                 handleChange(idx, 'is_paid', e.target.checked)
//                               }
//                               disabled={!canEdit}
//                             />
//                           }
//                           label="Paid"
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <TextField
//                           label="Paid On"
//                           type="datetime-local"
//                           fullWidth
//                           value={inst.paid_on ? inst.paid_on.slice(0, 16) : ''}
//                           onChange={(e) => handleChange(idx, 'paid_on', e.target.value)}
//                           InputLabelProps={{ shrink: true }}
//                           disabled={!isPaid || !canEdit}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <TextField
//                           label="Particulars"
//                           fullWidth
//                           value={inst.particulars || ''}
//                           onChange={(e) => handleChange(idx, 'particulars', e.target.value)}
//                           disabled={!isPaid || !canEdit}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <TextField
//                           label="Payment Reference Number"
//                           fullWidth
//                           value={inst.payment_reference_number || ''}
//                           onChange={(e) =>
//                             handleChange(idx, 'payment_reference_number', e.target.value)
//                           }
//                           disabled={!isPaid || !canEdit}
//                         />
//                       </Grid>

//                       {/* Paid By — preset methods + "Others" free text */}
//                       <Grid item xs={12} md={4}>
//                         <FormControl fullWidth disabled={!isPaid || !canEdit}>
//                           <InputLabel>Paid By</InputLabel>
//                           <Select
//                             label="Paid By"
//                             value={inst._paymentMethodMode || ''}
//                             onChange={(e) => handlePaymentMethodSelect(idx, e.target.value)}
//                           >
//                             {PAYMENT_METHOD_OPTIONS.map((opt) => (
//                               <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       {inst._paymentMethodMode === 'Others' && (
//                         <Grid item xs={12} md={4}>
//                           <TextField
//                             label="Specify Payment Method"
//                             fullWidth
//                             value={inst._customPaymentMethod || ''}
//                             onChange={(e) => handleCustomPaymentMethodChange(idx, e.target.value)}
//                             disabled={!isPaid || !canEdit}
//                           />
//                         </Grid>
//                       )}

//                       <Grid item xs={12} md={4}>
//                         <TextField
//                           label="Amount Received Bank"
//                           type="text"
//                           fullWidth
//                           value={inst.amt_received_bank_name || ''}
//                           onChange={(e) =>
//                             handleChange(idx, 'amt_received_bank_name', e.target.value)
//                           }
//                           disabled={!isPaid || !canEdit}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={inst.is_amt_received_office || false}
//                               onChange={(e) =>
//                                 handleChange(idx, 'is_amt_received_office', e.target.checked)
//                               }
//                               disabled={!isPaid || !canEdit}
//                             />
//                           }
//                           label="Amount Received"
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={4}>
//                         <TextField
//                           label="Amount Received On"
//                           type="datetime-local"
//                           fullWidth
//                           value={inst.amt_received_office_on ? inst.amt_received_office_on.slice(0,16) : ''}
//                           onChange={(e) =>
//                             handleChange(idx, 'amt_received_office_on', e.target.value)
//                           }
//                           InputLabelProps={{ shrink: true }}
//                           disabled={!isPaid || !canEdit}
//                         />
//                       </Grid>

//                       {/* Upload Statement */}
//                       <Grid item xs={12} md={8}>
//                         <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
//                           <Tooltip title={(!isPaid || !canEdit) ? '' : 'Upload payment statement (max 5 MB)'}>
//                             <span>
//                               <Button
//                                 size="small"
//                                 variant="outlined"
//                                 component="label"
//                                 startIcon={<UploadFileIcon fontSize="small" />}
//                                 disabled={!isPaid || !canEdit}
//                               >
//                                 {stagedFiles[idx] ? stagedFiles[idx].name : 'Upload Statement'}
//                                 <input
//                                   type="file"
//                                   hidden
//                                   accept=".pdf,.jpg,.jpeg,.png"
//                                   onChange={handleStatementFileChange(idx)}
//                                 />
//                               </Button>
//                             </span>
//                           </Tooltip>
//                           {inst.statement_link && (
//                             <Tooltip title="View uploaded statement">
//                               <IconButton
//                                 size="small"
//                                 component={Link}
//                                 href={inst.statement_link}
//                                 target="_blank"
//                                 rel="noopener"
//                               >
//                                 <VisibilityIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                           )}
//                         </Box>
//                       </Grid>
//                     </Grid>

//                     <Box mt={2}>
//                       <Grid item xs={12}>
//                         <TextField
//                           label="Remarks(Add Brief Notes for Office Use)"
//                           fullWidth
//                           multiline
//                           rows={2}
//                           value={inst.remarks || ''}
//                           onChange={(e) => handleChange(idx, 'remarks', e.target.value)}
//                           disabled={!canEdit}
//                         />
//                       </Grid>
//                     </Box>

//                     {!readOnly && (
//                       <Box mt={2} textAlign="right">
//                         <Button
//                           variant="contained"
//                           color="primary"
//                           onClick={() => handleUpdateInstallment(idx)}
//                           disabled={!canEdit || updatingIndex === idx}
//                         >
//                           {updatingIndex === idx ? 'Updating...' : 'Update'}
//                         </Button>
//                       </Box>
//                     )}
//                   </Paper>
//                 );
//               })
//             )}
//           </Stack>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={onClose} variant="outlined">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </>
//   );
// };

// export default InstallmentEditModal;


import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  Link,
  Divider,
  CircularProgress,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import api from '../../../api/axiosInterceptor';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { PAYMENT_METHOD_OPTIONS, MAX_INSTALLMENT_STATEMENT_FILE_SIZE } from './workflowApi';

const PRESET_METHODS = PAYMENT_METHOD_OPTIONS.filter((m) => m !== 'Others');

// readOnly: true once the case is closed — every field/button below is
// disabled so the installment history stays fully visible but uneditable.
const InstallmentEditModal = ({ open, onClose, excessId, readOnly = false }) => {
  const [installments, setInstallments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatingIndex, setUpdatingIndex] = useState(null);
  const [hasFetched, setHasFetched] = useState(false);
  const [stagedFiles, setStagedFiles] = useState({}); // { [idx]: File }

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const showError = (message) => {
    setSnackbarMessage(message);
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
  };

  // Augments each installment with transient (never sent to the backend)
  // UI-only fields so the "Paid By" dropdown can tell a preset method apart
  // from a custom "Others" value that's already stored in `payment_method`.
  const enrich = (list) =>
    list.map((item) => {
      const isPreset = PRESET_METHODS.includes(item.payment_method);
      return {
        ...item,
        _paymentMethodMode: item.payment_method ? (isPreset ? item.payment_method : 'Others') : '',
        _customPaymentMethod: item.payment_method && !isPreset ? item.payment_method : '',
      };
    });

  const fetchInstallments = async () => {
    if (!excessId) {
      setInstallments([]);
      setHasFetched(true);
      return;
    }

    try {
      setLoading(true);
      setHasFetched(false);
      const res = await api.get(`/excess_payment_mgmt/excess-installment-updater/${excessId}/`);
      setInstallments(Array.isArray(res.data) ? enrich(res.data) : []);
      setStagedFiles({});
      setHasFetched(true);
      if (!Array.isArray(res.data) || res.data.length === 0) {
        setSnackbarMessage('No Installment Found Please add it from Manage Document');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setInstallments([]);
      setHasFetched(true);
      showError(err.response?.data?.error || 'Failed to load installments');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchInstallments();
    } else {
      setInstallments([]);
      setStagedFiles({});
      setHasFetched(false);
      setUpdatingIndex(null);
      setLoading(false);
    }
  }, [open, excessId]);

  const handleChange = (index, field, value) => {
    if (readOnly) return;
    const updated = [...installments];
    updated[index][field] = value;

    if (field === 'is_paid' && value === true) {
      updated[index].is_updated = true;
    }

    setInstallments(updated);
  };

  // "Paid By" — preset methods write straight into payment_method; "Others"
  // switches the UI into free-text mode without touching payment_method
  // until the user actually types something, so a stray "Others" click
  // doesn't overwrite a previously-saved custom value.
  const handlePaymentMethodSelect = (index, value) => {
    if (readOnly) return;
    const updated = [...installments];
    updated[index]._paymentMethodMode = value;
    if (value !== 'Others') {
      updated[index].payment_method = value;
      updated[index]._customPaymentMethod = '';
    } else if (!updated[index]._customPaymentMethod) {
      updated[index].payment_method = '';
    }
    setInstallments(updated);
  };

  const handleCustomPaymentMethodChange = (index, value) => {
    if (readOnly) return;
    const updated = [...installments];
    updated[index]._customPaymentMethod = value;
    updated[index].payment_method = value; // stored directly in the same key
    setInstallments(updated);
  };

  const handleStatementFileChange = (index) => (e) => {
    if (readOnly) return;
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > MAX_INSTALLMENT_STATEMENT_FILE_SIZE) {
      showError(`Statement must be under ${Math.round(MAX_INSTALLMENT_STATEMENT_FILE_SIZE / (1024 * 1024))} MB.`);
      return;
    }
    setStagedFiles((prev) => ({ ...prev, [index]: file }));
  };

  // When an installment is marked Paid, these fields become mandatory
  // before the update can be submitted.
  const validatePaidFields = (installment) => {
    if (!installment.is_paid) return null;

    if (!installment.paid_on) return 'Please enter "Paid On" date/time.';
    if (!installment.particulars || !installment.particulars.trim()) return 'Please enter "Particulars".';
    if (!installment.payment_reference_number || !installment.payment_reference_number.trim())
      return 'Please enter "Payment Reference Number".';
    if (!installment._paymentMethodMode) return 'Please select "Paid By".';
    if (installment._paymentMethodMode === 'Others' && !installment._customPaymentMethod?.trim())
      return 'Please specify the payment method.';
    if (!installment.payment_method || !installment.payment_method.trim())
      return 'Please select or specify "Paid By".';
    if (!installment.amt_received_bank_name || !installment.amt_received_bank_name.trim())
      return 'Please enter "Amount Received Bank".';

    return null;
  };

  const handleUpdateInstallment = async (index) => {
    if (readOnly || !excessId) return;
    const installment = installments[index];
    const installmentId = installment.id;

    const validationError = validatePaidFields(installment);
    if (validationError) {
      showError(validationError);
      return;
    }

    const fd = new FormData();
    Object.keys(installment).forEach((key) => {
      // Skip transient UI-only fields — the backend has no columns for these.
      if (key.startsWith('_')) return;
      if (installment[key] !== undefined && installment[key] !== null) {
        fd.append(key, installment[key]);
      }
    });
    if (stagedFiles[index]) {
      fd.append('statement_file', stagedFiles[index]);
    }

    try {
      setUpdatingIndex(index);
      const res = await api.patch(
        `/excess_payment_mgmt/excess-installment-updater/${excessId}/${installmentId}/`,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      setSnackbarMessage('Installment updated successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);

      const updatedInstallments = [...installments];
      updatedInstallments[index] = {
        ...updatedInstallments[index],
        ...(res.data?.data || {}),
        is_updated: true,
      };
      setInstallments(enrich(updatedInstallments));
      setStagedFiles((prev) => {
        const next = { ...prev };
        delete next[index];
        return next;
      });
    } catch (err) {
      showError(err.response?.data?.error || 'Failed to update installment');
    } finally {
      setUpdatingIndex(null);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            minWidth: { xs: '100%', sm: 640, md: 900 },
            borderRadius: 3,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: '1.35rem',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            py: 2.25,
            px: 3,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          Edit Installments
          {readOnly && (
            <Chip
              icon={<LockOutlinedIcon fontSize="small" />}
              label="Closed — View Only"
              size="small"
              color="warning"
              variant="outlined"
              sx={{ fontWeight: 600 }}
            />
          )}
        </DialogTitle>

        <DialogContent
          dividers={false}
          sx={{
            bgcolor: 'grey.50',
            px: { xs: 2, sm: 3 },
            py: 3,
          }}
        >
          <Stack spacing={2.5}>
            {loading ? (
              <Box display="flex" flexDirection="column" alignItems="center" gap={1.5} py={6}>
                <CircularProgress size={28} />
                <Typography color="text.secondary">Loading installments...</Typography>
              </Box>
            ) : hasFetched && installments.length === 0 ? (
              <Box
                sx={{
                  textAlign: 'center',
                  py: 6,
                  px: 3,
                  border: '1px dashed',
                  borderColor: 'divider',
                  borderRadius: 2,
                  bgcolor: 'background.paper',
                }}
              >
                <Typography color="text.secondary" sx={{ fontWeight: 600 }}>
                  No Installment Found. Please add it from Manage Document.
                </Typography>
              </Box>
            ) : (
              installments.map((inst, idx) => {
                const isPaid = inst.is_paid || false;

                const canEdit =
                  !readOnly &&
                  (idx === 0 || installments[idx - 1]?.is_paid || installments[idx - 1]?.is_updated);

                return (
                  <Paper
                    key={inst.id}
                    elevation={0}
                    sx={{
                      p: { xs: 2, sm: 3 },
                      borderRadius: 2,
                      position: 'relative',
                      opacity: canEdit || readOnly ? 1 : 0.65,
                      border: '1px solid',
                      borderColor: isPaid ? 'success.light' : 'divider',
                      transition: 'box-shadow 0.15s ease',
                      '&:hover': { boxShadow: canEdit ? 2 : 0 },
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1.25} sx={{ mb: 2 }}>
                      <Box
                        sx={{
                          width: 32,
                          height: 32,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: isPaid ? 'success.main' : 'grey.300',
                          color: isPaid ? 'success.contrastText' : 'text.secondary',
                          flexShrink: 0,
                        }}
                      >
                        {isPaid ? (
                          <CheckCircleIcon sx={{ fontSize: 20 }} />
                        ) : (
                          <HourglassEmptyIcon sx={{ fontSize: 18 }} />
                        )}
                      </Box>
                      <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.05rem' }}>
                        Installment {idx + 1}
                      </Typography>
                      <Chip
                        size="small"
                        label={isPaid ? 'Paid' : 'Pending'}
                        color={isPaid ? 'success' : 'default'}
                        variant={isPaid ? 'filled' : 'outlined'}
                        sx={{ ml: 'auto', fontWeight: 600 }}
                      />
                    </Stack>

                    <Divider sx={{ mb: 2.5 }} />

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Installment Amount"
                          type="number"
                          fullWidth
                          size="small"
                          sx={{ minWidth: 180 }}
                          value={inst.installment_amount || ''}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Due Date"
                          type="date"
                          fullWidth
                          size="small"
                          sx={{ minWidth: 180 }}
                          value={inst.installment_due_date || ''}
                          onChange={(e) =>
                            handleChange(idx, 'installment_due_date', e.target.value)
                          }
                          InputLabelProps={{ shrink: true }}
                          disabled={!canEdit}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <FormControlLabel
                          sx={{ minWidth: 120 }}
                          control={
                            <Checkbox
                              checked={isPaid}
                              onChange={(e) =>
                                handleChange(idx, 'is_paid', e.target.checked)
                              }
                              disabled={!canEdit}
                            />
                          }
                          label="Paid"
                        />
                      </Grid>

                      {/* Paid By — preset methods + "Others" free text. Shown right after
                          the Paid checkbox since it's the first thing to fill once Paid is checked. */}
                      <Grid item xs={12} sm={6} md={4}>
                        <FormControl fullWidth size="small" sx={{ minWidth: 180 }} disabled={!isPaid || !canEdit} required={isPaid}>
                          <InputLabel>Paid By</InputLabel>
                          <Select
                            label="Paid By"
                            value={inst._paymentMethodMode || ''}
                            onChange={(e) => handlePaymentMethodSelect(idx, e.target.value)}
                          >
                            {PAYMENT_METHOD_OPTIONS.map((opt) => (
                              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      {inst._paymentMethodMode === 'Others' && (
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            label="Specify Payment Method"
                            fullWidth
                            size="small"
                            required={isPaid}
                            sx={{ minWidth: 180 }}
                            value={inst._customPaymentMethod || ''}
                            onChange={(e) => handleCustomPaymentMethodChange(idx, e.target.value)}
                            disabled={!isPaid || !canEdit}
                          />
                        </Grid>
                      )}

                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Paid On"
                          type="datetime-local"
                          fullWidth
                          size="small"
                          required={isPaid}
                          sx={{ minWidth: 220 }}
                          value={inst.paid_on ? inst.paid_on.slice(0, 16) : ''}
                          onChange={(e) => handleChange(idx, 'paid_on', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          disabled={!isPaid || !canEdit}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Particulars"
                          fullWidth
                          size="small"
                          required={isPaid}
                          sx={{ minWidth: 180 }}
                          value={inst.particulars || ''}
                          onChange={(e) => handleChange(idx, 'particulars', e.target.value)}
                          disabled={!isPaid || !canEdit}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Payment Reference Number"
                          fullWidth
                          size="small"
                          required={isPaid}
                          sx={{ minWidth: 180 }}
                          value={inst.payment_reference_number || ''}
                          onChange={(e) =>
                            handleChange(idx, 'payment_reference_number', e.target.value)
                          }
                          disabled={!isPaid || !canEdit}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Amount Received Bank"
                          type="text"
                          fullWidth
                          size="small"
                          required={isPaid}
                          sx={{ minWidth: 180 }}
                          value={inst.amt_received_bank_name || ''}
                          onChange={(e) =>
                            handleChange(idx, 'amt_received_bank_name', e.target.value)
                          }
                          disabled={!isPaid || !canEdit}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <FormControlLabel
                          sx={{ minWidth: 160 }}
                          control={
                            <Checkbox
                              checked={inst.is_amt_received_office || false}
                              onChange={(e) =>
                                handleChange(idx, 'is_amt_received_office', e.target.checked)
                              }
                              disabled={!isPaid || !canEdit}
                            />
                          }
                          label="Amount Received"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Amount Received On"
                          type="datetime-local"
                          fullWidth
                          size="small"
                          sx={{ minWidth: 220 }}
                          value={inst.amt_received_office_on ? inst.amt_received_office_on.slice(0, 16) : ''}
                          onChange={(e) =>
                            handleChange(idx, 'amt_received_office_on', e.target.value)
                          }
                          InputLabelProps={{ shrink: true }}
                          disabled={!isPaid || !canEdit}
                        />
                      </Grid>

                      {/* Upload Statement */}
                      <Grid item xs={12} md={8}>
                        <Box display="flex" alignItems="center" flexWrap="wrap" gap={1.5}>
                          <Tooltip title={(!isPaid || !canEdit) ? '' : 'Upload payment statement (max 5 MB)'}>
                            <span>
                              <Button
                                size="small"
                                variant="outlined"
                                component="label"
                                startIcon={<UploadFileIcon fontSize="small" />}
                                disabled={!isPaid || !canEdit}
                                sx={{ minWidth: 180, textTransform: 'none' }}
                              >
                                {stagedFiles[idx] ? stagedFiles[idx].name : 'Upload Statement'}
                                <input
                                  type="file"
                                  hidden
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  onChange={handleStatementFileChange(idx)}
                                />
                              </Button>
                            </span>
                          </Tooltip>
                          {inst.statement_link && (
                            <Tooltip title="View uploaded statement">
                              <IconButton
                                size="small"
                                component={Link}
                                href={inst.statement_link}
                                target="_blank"
                                rel="noopener"
                                sx={{ border: '1px solid', borderColor: 'divider' }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </Grid>
                    </Grid>

                    <Box mt={2.5}>
                      <TextField
                        label="Remarks (Add Brief Notes for Office Use)"
                        fullWidth
                        multiline
                        rows={2}
                        size="small"
                        value={inst.remarks || ''}
                        onChange={(e) => handleChange(idx, 'remarks', e.target.value)}
                        disabled={!canEdit}
                      />
                    </Box>

                    {!readOnly && (
                      <Box mt={2.5} textAlign="right">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleUpdateInstallment(idx)}
                          disabled={!canEdit || updatingIndex === idx}
                          sx={{ textTransform: 'none', fontWeight: 600, minWidth: 120, borderRadius: 1.5 }}
                        >
                          {updatingIndex === idx ? 'Updating...' : 'Update'}
                        </Button>
                      </Box>
                    )}
                  </Paper>
                );
              })
            )}
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Button onClick={onClose} variant="outlined" sx={{ textTransform: 'none', minWidth: 100 }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </>
  );
};

export default InstallmentEditModal;